import React from 'react'

const ConnectionIcon = () => {
  return (
    <svg
      width="11"
      height="72"
      viewBox="0 0 11 72"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="5.5" cy="5.5" r="5.5" fill="#3249D7" />
      <circle cx="5.5" cy="5.5" r="2.5" fill="white" />
      <rect x="5" y="21" width="1" height="30" fill="#3249D7" />
      <circle cx="5.5" cy="66.5" r="5.5" fill="#3249D7" />
      <circle cx="5.5" cy="66.5" r="2.5" fill="white" />
    </svg>
  )
}

export default ConnectionIcon
